/**
 * Checkout Form Filter
 * 在表单提交前过滤掉内部属性，但保留embroidery产品显示
 * 通过直接操作表单DOM元素实现，不使用cart API
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Checkout filter initialized');

  // 监听表单提交事件
  document.addEventListener('submit', function(event) {
    const form = event.target;

    // 检查是否是购物车表单且包含checkout
    if (isCartCheckoutForm(form)) {
      console.log('Cart checkout form detected, filtering internal properties...');

      // 过滤内部属性input字段
      filterInternalProperties(form);
    }
  });

  // 检查是否是购物车checkout表单
  function isCartCheckoutForm(form) {
    // 检查表单action是否指向cart
    const isCartForm = form.action && (form.action.includes('/cart') || form.action.endsWith('/cart'));

    // 检查是否有checkout相关的提交
    const hasCheckout = form.querySelector('[name="checkout"]') ||
                       form.querySelector('button[name="checkout"]') ||
                       form.querySelector('input[name="checkout"]');

    return isCartForm && hasCheckout;
  }

  // 过滤表单中的内部属性input字段
  function filterInternalProperties(form) {
    if (!form) return;

    try {
      console.log('Starting to filter internal properties...');

      // 过滤内部属性input（以下划线开头的addon相关属性）
      filterInternalPropertyInputs(form);

      console.log('Internal property filtering completed');

    } catch (error) {
      console.error('Error filtering internal properties:', error);
    }
  }

  // 过滤内部属性input
  function filterInternalPropertyInputs(form) {
    // 查找所有属性相关的input
    const propertyInputs = form.querySelectorAll('input[name*="properties"], input[name*="attributes"]');

    console.log('Found property inputs:', propertyInputs.length);

    propertyInputs.forEach(input => {
      const name = input.name;
      const nameLower = name.toLowerCase();

      // 过滤掉不需要在checkout显示的内部属性
      if (shouldFilterProperty(name, nameLower)) {
        console.log('Filtering out internal property input:', input.name, '=', input.value);
        // 完全移除input元素，确保不会被提交
        input.remove();
      }
    });
  }

  // 判断是否应该过滤该属性
  function shouldFilterProperty(originalName, lowerName) {
    // 精确匹配属性名称 - 新的addon token相关属性
    const exactMatches = [
      'properties[_addonToken]',
      'properties[_hasAddons]',
      'properties[_Embroidery Color Value]',  // 保留这个以防向后兼容
      'properties[_embroidery_product_key]'   // 保留这个以防向后兼容
    ];

    // 模糊匹配模式 - 所有以下划线开头的内部属性
    const patterns = [
      '_addontoken',
      '_hasaddons',
      '_embroidery color value',
      '_embroidery_product_key'
    ];

    // 先检查精确匹配
    if (exactMatches.includes(originalName)) {
      return true;
    }

    // 再检查模糊匹配
    return patterns.some(pattern => lowerName.includes(pattern));
  }
});
